// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: 'AIzaSyDzKwle2scXTj9e0n72kAVVMhj9GDqohFA',
    authDomain: 'cafe1888-654a4.firebaseapp.com',
    databaseURL: null,
    projectId: 'cafe1888-654a4',
    storageBucket: 'cafe1888-654a4.appspot.com',
    messagingSenderId: '994397746277',
    appId: '1:994397746277:web:8232a251726f72cdec828c',
    measurementId: null
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
